import { Instance, types } from 'mobx-state-tree';
import { RTModel } from './RTModel';

const Notification = types.model('Notification', {
  message: types.string,
  variant: types.union(
    types.literal('default'),
    types.literal('error'),
    types.literal('success'),
    types.literal('warning'),
    types.literal('info'),
  ),
  persist: false,
});

// The school bell (sq_api tutor_sessions/break_bells.py). `firedAt` is what
// makes two bells of the same kind distinguishable, so the banner can tell a
// fresh 11:15 eye break from the 10:15 one it already showed.
const BreakBell = types.model('BreakBell', {
  kind: types.union(types.literal('small'), types.literal('big')),
  durationMinutes: types.number,
  firedAt: types.string,
});

const TutorSessionCoachAdminState = RTModel.named('TutorSessionCoachAdminState')
  .props({
    coachCurrentRoom: types.maybeNull(types.string),
    coachScrollPosition: types.maybeNull(types.number),
    notify: types.maybe(Notification),
    breakBell: types.maybe(BreakBell),
  })
  .actions((self) => ({
    setCoachCurrentRoom(name: string | null) {
      self.coachCurrentRoom = name;
    },
    setCoachScrollPosition(position: number) {
      self.coachScrollPosition = position;
    },
  }));

export default TutorSessionCoachAdminState;
export interface ITutorSessionCoachAdminState extends Instance<typeof TutorSessionCoachAdminState> {}
